

import './Task.scss';
import { Draggable } from '@hello-pangea/dnd';

const Task = (props) => {
 
  //INDICATE RESULT CSS
  let styleClassName;

  if (!props.isSelected) {

  styleClassName = `${'Task'}`;

 } else if (!props.styleAnswer.flag) {
  styleClassName = `${'Task'} ${'wrongAnswer'}`;

 } else if (props.styleAnswer.flag) {
     
    styleClassName = `${'Task'} ${'rightAnswer'}`;  
    
 }

  console.log(props.isSelected);
  console.log(props.styleAnswer);


  const Container = (props) => {

    const { provided, innerRef } = props;


// className={(props.isSelected && props.styleAnswer.flag) ? 'TasrightAnswer' : 'wrongAnswer'}
    return (
      <div   className={styleClassName} 
      ref={innerRef} {...provided.draggableProps} {...provided.dragHandleProps}
        >
          {props.index+1}. {props.task.content}
      </div>
    )
  }



    return (
      <Draggable draggableId={props.task.id} index={props.index}>
        
          {provided => 
            <Container 
            task={props.task} 
            innerRef={provided.innerRef} 
            provided={provided} 
            styleAnswer={props.styleAnswer}
            isSelected={props.isSelected}
            index={props.index}
            />
 
          }
   
      </Draggable>
    );




  }
  
  export default Task;